/**
 * Centralized playback and polling timing constants.
 *
 * Tune these to adjust player behavior across the app. They are shared between
 * NowPlayingContext hooks (useManifest, usePlayback, useWordTracking) and
 * GenerationContext.
 */

// Time before the manifest-reported end of the current audio chunk at which
// we trigger the chunk advance. Kept small so we don't cut off real audio
// (old 0.15s value was dropping ~150ms of content per chunk and nudging
// globalTime forward by 0.15s at every boundary, contributing to highlight
// drift). A proper 'ended' listener is the belt-and-suspenders fallback for
// when the timeupdate check misses by a frame.
export const CHUNK_ADVANCE_BUFFER_SECONDS = 0.03;

// Base lead time for word highlighting. The rAF loop adds this to the current
// audio time before looking up the "current" word in the binary search.
// Each word also has a per-word `leadTimeMultiplier` that scales this value.
export const BASE_LEAD_TIME_SECONDS = 0.060;

// How often to poll the backend for generation progress.
export const POLL_INTERVAL_MS = 1500;

// Max polls before giving up (~10 minutes at 1.5s intervals).
export const MAX_POLL_ATTEMPTS = 400;
